function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import __ from 'ramda/src/__';
import pathOr from 'ramda/src/pathOr';
import propEq from 'ramda/src/propEq';
import i18n from 'invision-core/src/components/i18n/i18n';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import CustomerCareKeys from '../../../../locales/keys';
import { BILLER_RULE_CYCLE_LEVEL, BILLER_RULE_INSTANCE_TYPE, INVOICE_TIMING_CONSTANTS, ORDER_SCENARIOS } from '../../../../customercare.constants';
import { CHARGE_TIMING } from '../../../../reducers/constants/wizard.constants';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { MetadataCodeLoadedSelector, MetadataCodeTypeSansGlobalSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { OfferingMetadataByIdSelector, OfferingMetadataPricingPlansSelector } from 'invision-core/src/components/metadata/offerings/offerings.selectors';
import { AMOUNT_TYPES, getSummaryTotalsLabel } from '../../../../reducers/helpers/summary.tab.helper';
import { MINI_CART_MORE_ACTIONS, moreActionMenuItems } from './summary.tab.helper';
import { getRetrieveOrderQuoteCountdown } from '../../../../reducers/helpers/async.helper';
var SummaryTabController = /*#__PURE__*/function () {
  function SummaryTabController($ngRedux, $scope, $timeout, uiNotificationService) {
    _classCallCheck(this, SummaryTabController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $scope: $scope,
      $timeout: $timeout,
      AMOUNT_TYPES: AMOUNT_TYPES,
      CHARGE_TIMING: CHARGE_TIMING,
      customerCareKeys: CustomerCareKeys,
      disconnectRedux: null,
      editMenuItems: moreActionMenuItems([MINI_CART_MORE_ACTIONS.CHANGE, MINI_CART_MORE_ACTIONS.EDIT, MINI_CART_MORE_ACTIONS.REMOVE]),
      editMenuItemsWithoutChange: moreActionMenuItems([MINI_CART_MORE_ACTIONS.EDIT, MINI_CART_MORE_ACTIONS.REMOVE]),
      getBriAmountByType: this.getBriAmountByType.bind(this),
      getBriDiscountByType: this.getBriDiscountByType.bind(this),
      getBriType: this.getBriType.bind(this),
      getRetrieveOrderQuoteCountdown: getRetrieveOrderQuoteCountdown,
      getSummaryTotalsLabel: getSummaryTotalsLabel,
      handleEditItemAction: this.handleEditItemAction.bind(this),
      handleMoreActionSelected: this.handleMoreActionSelected.bind(this),
      handleRemoveItemAction: this.handleRemoveItemAction.bind(this),
      removeMenuItems: moreActionMenuItems([MINI_CART_MORE_ACTIONS.REMOVE]),
      showRefundMessage: this.showRefundMessage.bind(this),
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(SummaryTabController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var codeTables = [CODES.RegularExpression, CODES.ServiceAttribute, CODES.OffCycleConfig];
      this.connectRedux();
      this.shouldShowCaveat = function () {
        if (!_this.isCheckoutStep || !_this.caveatMessages) {
          return false;
        } else if (_this.viewModel.dueTotals && _this.viewModel.dueTotals.orderQuoteTotals) {
          return _this.viewModel.dueTotals.orderQuoteTotals.some(function (item) {
            return item.chargeTiming === CHARGE_TIMING.BILL_CYCLE;
          });
        } else {
          return _this.isCheckoutStep;
        }
      };
      this.anyIconsShown = function () {
        var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return products.some(function (product) {
          return product.isAdded || product.isRemoved || product.isSwapped;
        });
      };
      this.isInvoiceImmediately = function (billerRule) {
        return pathOr(0, ['InvoiceTiming'], billerRule) === INVOICE_TIMING_CONSTANTS.INVOICE_IMMEDIATELY;
      };
      this.getChargeToolTipIcon = function (billerRule) {
        var invoiceTiming = pathOr(null, ['InvoiceTiming'], billerRule);
        switch (invoiceTiming) {
          case INVOICE_TIMING_CONSTANTS.INVOICE_IMMEDIATELY:
            return 'exclamation-circle';
          case INVOICE_TIMING_CONSTANTS.INVOICE_ON_CYCLE:
            return 'exclamation-circle';
          default:
            return null;
        }
      };
      this.getTermLength = function (product) {
        return product.termLength || product.billerRule.TermLength || product.billerRule.DefaultTermLength;
      };
      codeTables.forEach(function (codeType) {
        if (!_this.state.codeTypeLoaded(codeType)) {
          _this.actions.fetchCodeTypes(codeType).catch(function (error) {
            _this.uiNotificationService.transientError(error.translatedMessage);
          });
        }
      });
      this.getChargeToolTipText = function (billerRule) {
        var invoiceTiming = pathOr(null, ['InvoiceTiming'], billerRule);
        switch (invoiceTiming) {
          case INVOICE_TIMING_CONSTANTS.INVOICE_IMMEDIATELY:
            return i18n.translate(_this.customerCareKeys.CART.INVOICE_IMMEDIATELY);
          case INVOICE_TIMING_CONSTANTS.INVOICE_ON_CYCLE:
            return i18n.translate(_this.customerCareKeys.CART.INVOICE_ON_CYCLE);
          default:
            return null;
        }
      };
      this.contractTermsConditionsPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.contractTermsConditionsPopupApi = event.api;
        }
      };
      this.openContractTermsConditionsPopup = function () {
        _this.contractTermsConditionsPopupOpened = true;
        _this.$timeout(function () {
          _this.contractTermsConditionsPopupApi.open();
        });
      };
      this.handleCloseContractTermsConditionsPopup = function () {
        _this.contractTermsConditionsPopupApi.close();
        _this.contractTermsConditionsPopupOpened = false;
      };
      this.hasNegativeDueToday = function () {
        var _this$viewModel, _this$viewModel$dueTo, _this$viewModel$dueTo2;
        return (_this$viewModel = _this.viewModel) === null || _this$viewModel === void 0 ? void 0 : (_this$viewModel$dueTo = _this$viewModel.dueTotals) === null || _this$viewModel$dueTo === void 0 ? void 0 : (_this$viewModel$dueTo2 = _this$viewModel$dueTo.orderQuoteTotals) === null || _this$viewModel$dueTo2 === void 0 ? void 0 : _this$viewModel$dueTo2.some(function (item) {
          return item.chargeTiming === CHARGE_TIMING.DUE_TODAY && item.totalAmount < 0;
        });
      };
      this.hasOffCycle = function () {
        return Object.values(_this.state.offeringMetadata).some(function (offeringMetaData) {
          return offeringMetaData.BillerRuleCycleLevel === BILLER_RULE_CYCLE_LEVEL.ITEM;
        });
      };
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "connectRedux",
    value: function connectRedux() {
      var _this2 = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          codeTypeLoaded: MetadataCodeLoadedSelector(__, store),
          isDbss: IsDbss(store),
          offCycleConfiguration: MetadataCodeTypeSansGlobalSelector(CODES.OffCycleConfig, store),
          offeringMetadataPricingPlans: OfferingMetadataPricingPlansSelector(store),
          offeringMetadata: OfferingMetadataByIdSelector(store)
        };
      };
      var controllerActions = {
        fetchCodeTypes: fetchCodeTypes
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this2.state = state;
        _this2.actions = actions;
      });
    }
  }, {
    key: "handleEditItemAction",
    value: function handleEditItemAction(action, offeringInstanceId, offeringId) {
      switch (action) {
        case MINI_CART_MORE_ACTIONS.CHANGE:
          this.onChangeOffer()(offeringInstanceId, offeringId);
          break;
        case MINI_CART_MORE_ACTIONS.EDIT:
          this.onEditOffer()(offeringInstanceId);
          break;
        case MINI_CART_MORE_ACTIONS.REMOVE:
          this.onRemoveOffer()(offeringInstanceId);
          break;
        default:
          break;
      }
    }
  }, {
    key: "getChargeTimingTitle",
    value: function getChargeTimingTitle(chargeTime) {
      switch (convertStringToNumber(chargeTime)) {
        case CHARGE_TIMING.BILL_CYCLE:
          return i18n.translate(CustomerCareKeys.CHARGE_TIMING.ADDED_NEXT_INVOICE);
        case CHARGE_TIMING.DUE_ON_ACTIVATION:
          return i18n.translate(CustomerCareKeys.CHARGE_TIMING.DUE_ON_ACTIVATION);
        case CHARGE_TIMING.DUE_ON_FIRST_USE:
          return i18n.translate(CustomerCareKeys.CHARGE_TIMING.DUE_ON_FIRST_USE);
        case CHARGE_TIMING.DUE_TODAY:
          return i18n.translate(CustomerCareKeys.CHARGE_TIMING.DUE_TODAY);
        default:
          break;
      }
    }
  }, {
    key: "getSubtotalAmount",
    value: function getSubtotalAmount(chargeTime) {
      switch (convertStringToNumber(chargeTime)) {
        case CHARGE_TIMING.BILL_CYCLE:
          return this.viewModel.dueSubTotals.dueNextInvoice.subTotal;
        case CHARGE_TIMING.DUE_ON_ACTIVATION:
          return this.viewModel.dueSubTotals.dueOnActivation.subTotal;
        case CHARGE_TIMING.DUE_ON_FIRST_USE:
          return this.viewModel.dueSubTotals.dueOnFirstUse.subTotal;
        case CHARGE_TIMING.DUE_TODAY:
          return this.viewModel.dueSubTotals.dueToday.subTotal;
        default:
          break;
      }
    }
  }, {
    key: "handleRemoveItemAction",
    value: function handleRemoveItemAction(offeringInstanceId) {
      this.onRemoveOffer()(offeringInstanceId);
    }
  }, {
    key: "getBriType",
    value: function getBriType(charge) {
      switch (charge.type) {
        case BILLER_RULE_INSTANCE_TYPE.RECURRING:
          return i18n.translate(this.customerCareKeys.CART_SUMMARY.RECURRING);
        case BILLER_RULE_INSTANCE_TYPE.ONETIME:
          return i18n.translate(this.customerCareKeys.CART_SUMMARY.ONE_TIME);
        default:
          break;
      }
    }
  }, {
    key: "getBriAmountByType",
    value: function getBriAmountByType(charge, product) {
      if (product.hasOverriddenPrice) {
        var overriddenCharge = (product.billerRuleDetails || []).find(function (billerRuleDetails) {
          //there can be multiple recurring charges so need to compare by id as well as type in case of recurring charge
          return charge.type === BILLER_RULE_INSTANCE_TYPE.RECURRING || charge.type === BILLER_RULE_INSTANCE_TYPE.ONETIME ? charge.billerRuleConfigurationId === billerRuleDetails.billerRuleConfigurationId : billerRuleDetails.type === charge.type;
        });
        return overriddenCharge && typeof overriddenCharge.amount === 'number' ? overriddenCharge.amount : charge.amount;
      } else {
        switch (charge.type) {
          case BILLER_RULE_INSTANCE_TYPE.RECURRING:
            return charge.amount;
          case BILLER_RULE_INSTANCE_TYPE.ONETIME:
            return charge.amount;
          default:
            break;
        }
      }
    }
  }, {
    key: "getBriDiscountByType",
    value: function getBriDiscountByType(charge) {
      switch (charge.type) {
        case BILLER_RULE_INSTANCE_TYPE.RECURRING:
          return charge.discount;
        case BILLER_RULE_INSTANCE_TYPE.ONETIME:
          return charge.discount;
        case BILLER_RULE_INSTANCE_TYPE.FINANCE:
          return charge.discount;
        default:
          break;
      }
    }
  }, {
    key: "handleMoreActionSelected",
    value: function handleMoreActionSelected(action, offeringInstanceId, offeringId) {
      if (this.onMoreActionSelected()) {
        this.onMoreActionSelected()(action, offeringInstanceId, offeringId);
      }
    }
  }, {
    key: "showRefundMessage",
    value: function showRefundMessage() {
      var isAutomaticProratedCreditDisabled = this.state.offCycleConfiguration.some(function (offCycleConfig) {
        return offCycleConfig.AdditionalProperties.find(propEq('disable_automatic_prorated_credit', 'Key')).Value === 'True';
      });
      return (this.orderScenario === ORDER_SCENARIOS.CHANGE_ORDER || this.orderScenario === ORDER_SCENARIOS.TRANSITION_OFFER) && isAutomaticProratedCreditDisabled && this.hasOffCycle() && this.hasNegativeDueToday();
    }
  }, {
    key: "isBriOptionBulk",
    value: function isBriOptionBulk(pricingPlanId, billerRule) {
      var _this3 = this;
      if (!Array.isArray(billerRule)) {
        return this.state && this.state.offeringMetadataPricingPlans[pricingPlanId] && this.state.offeringMetadataPricingPlans[pricingPlanId].BillerRuleInstanceThumbnails.some(function (briThumbnail) {
          return briThumbnail.Bulk && briThumbnail.BillerRuleConfigurationId === billerRule.BillerRuleConfigurationId;
        });
      } else {
        return billerRule.some(function (bri) {
          return _this3.state && _this3.state.offeringMetadataPricingPlans[pricingPlanId] && _this3.state.offeringMetadataPricingPlans[pricingPlanId].BillerRuleInstanceThumbnails.some(function (briThumbnail) {
            return briThumbnail.Bulk && briThumbnail.BillerRuleConfigurationId === bri.BillerRuleConfigurationId;
          });
        });
      }
    }
  }]);
}();
export default {
  template: require('./summary.tab.html'),
  bindings: {
    caveatMessages: '<?',
    displayEditableItemsOnly: '<?',
    displayRemoveItems: '<?',
    displaySummaryTab: '<?',
    editableItems: '<?',
    hasSubscriptionQuote: '<?',
    isCheckoutStep: '<?',
    orderScenario: '<?',
    isDiscountHidden: '<?',
    isMultiOffer: '<?',
    isQuoteBypassed: '<?',
    moreActionMenuItems: '<',
    onChangeOffer: '&?',
    onEditOffer: '&?',
    onMoreActionSelected: '&?',
    onPreviewRenewalStatements: '&?',
    onRefreshQuote: '&?',
    onRemoveOffer: '&?',
    removableItems: '<?',
    retrieveOrderQuoteTimestamp: '<?',
    selectedOfferingServiceIdentifiers: '<?',
    viewModel: '<' // See SummaryTabViewModel in new.connect.wizard.selectors.js,
  },
  controller: SummaryTabController,
  controllerAs: 'summaryTabController'
};